import { INursingStations } from './../models/service/nursing-stations.model';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IUnitDetails } from '../models/service/units-details.model';
import { IPatronDetails } from '../models/service/patron-details.model';
import { ServiceTicketResponseI } from '../models/service/serviceTicket.model';
import { EnvironmentData } from '../../environments/environment-data';
import { AuthConnectProvider } from '../providers/account/auth-connect';
import { IPatronTrayDetails } from '../models/service/patron-tray-details.model';
import { IMeals } from '../models/service/meals.model';

@Injectable({
  providedIn: 'root',
})
export class UnitsService {
  constructor(private http: HttpClient) { }

  public async getUnitById(unitId: number): Promise<IUnitDetails[]> {
    const response = await this.http
      .get<IUnitDetails[]>(
        `${EnvironmentData.getTLUrl()}/UnitDetails/${AuthConnectProvider.getSettings()?.organizationId
        }/${unitId}`,
      )
      .toPromise();
    return response;
  }

  public async getServiceTickets(
    ticketId: number,
  ): Promise<ServiceTicketResponseI> {
    const response = await this.http
      .get<ServiceTicketResponseI>(
        `${EnvironmentData.getTLUrl()}/Tickets/${AuthConnectProvider.getSettings()?.organizationId
        }/ServiceTickets/${ticketId}`,
      )
      .toPromise();
    return response;
  }

  public async getNursingStations(): Promise<INursingStations> {
    const request = await this.http
      .get<INursingStations>(
        `${EnvironmentData.getTLUrl()}/NursingStations/${AuthConnectProvider.getSettings()?.organizationId
        }`,
      )
      .toPromise();
    return request;
  }

  public async getPatronDetails(
    admissionId: number,
    isPHIShown: any,
  ): Promise<IPatronDetails> {
    const request = await this.http
      .get<IPatronDetails>(
        `${EnvironmentData.getTLUrl()}/patrons/${AuthConnectProvider.getSettings()?.organizationId
        }/admission/${admissionId}?includeTickets=true&showPatientInfo=${isPHIShown}`,
      )
      .toPromise();
    return request;
  }

  public async getPatronTrayDetails(
    admissionId: number,
    trayId: string,
    unitDetail: IUnitDetails,
  ): Promise<IPatronTrayDetails> {
    const query =
      unitDetail.trayStatus === 'Queued'
        ? `queueId=${unitDetail.queueId}`
        : `trayId=${trayId}`;
    const request = await this.http
      .get<IPatronTrayDetails>(
        `${EnvironmentData.getTLUrl()}/patronTrayDetails/${AuthConnectProvider.getSettings()?.organizationId
        }/${admissionId}?${query}`,
      )
      .toPromise();
    return request;
  }
  public async getPatronTrayDetailsWithTrayId(
    admissionId: number,
    trayId: string,
  ): Promise<IPatronTrayDetails> {
    const response = await this.http
      .get<IPatronTrayDetails>(
        `${EnvironmentData.getTLUrl()}/patronTrayDetails/${AuthConnectProvider.getSettings()?.organizationId
        }/${admissionId}?${trayId}`,
      )
      .toPromise();
    if (!response || !response.data.length) {
      return null;
    }
    return response;
  }

  public async getMeals(): Promise<IMeals[]> {
    const request = await this.http
      .get<IMeals[]>(
        `${EnvironmentData.getTLUrl()}/meals/${AuthConnectProvider.getSettings()?.organizationId
        }`,
      )
      .toPromise();
    return request;
  }
}
